import { Fragment } from "react";
import cs from "classnames";
import Typography from "components/Typography";
import styles from "pages/Home/styles.module.scss";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Text,
} from "@chakra-ui/react";
import React from "react";

const resultsScoresLegendItems = [
  {
    color: "green",
    info: "Vehicles in this category meet key performance benchmarks for sales success, based on critical data points such as overall views, inventory age, leads, merchandising, deal ratings (if applicable), and competitive pricing. These units are primed to sell quickly, meaning additional marketing spend is unnecessary. Focus on maintaining momentum rather than overspending on advertising.",
  },
  {
    color: "yellow",
    info: "Vehicles in this category have areas for improvement that could enhance marketing effectiveness. Our cutting-edge Results Scoring Model pinpoints the exact deficiencies, eliminating guesswork from your strategy. With VinDrives’ market-leading intelligence, you can identify where to optimize your marketing spend and allocate resources with precision—maximizing results without wasted budget.",
  },
  {
    color: "red",
    info: "Vehicles in this category are underperforming and require strategic intervention to generate sales activity. These high-risk units present an opportunity for targeted marketing adjustments to drive engagement. Our Results Scoring Model provides actionable insights to help you prioritize budget allocation effectively, ensuring your marketing dollars are spent where they will yield the highest return.",
  },
];

export const ResultScoresLegend = () => {

  return (
    <>
      <Accordion
        allowToggle={true}
        defaultIndex={0}
        borderColor="gray.200"
      >
        <AccordionItem
          borderWidth="1px !important"
        >
          <AccordionButton
            borderColor="inherit"
            borderBottom="1px"
            borderBottomColor="gray.200"
          >
            <Box as="span" flex="1" textAlign="left">
              <Text fontSize="xl" fontWeight={600}>
                What are Result Scores?
              </Text>
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel>
            <Text fontSize={14} paddingBottom={10}>
              Result Scores are VinDrives' proprietary analysis and grading of
              actionable Key Performance Indicators (KPIs) and Critical Success
              Factors (CSFs) of the dealership's VDP views and subsequent
              actions as measured against the dealership's potential sales
              metrics and goals.
            </Text>
            <div className={styles["resultScoresLegend__items"]}>
              {resultsScoresLegendItems.map(({ color, info }, index) => (
                <Fragment key={index}>
                  <div className={styles["resultScoresLegend__items__legend"]}>
                    <Typography
                      fontSize="text-md"
                      fontWeight="semibold"
                      className={cs(
                        styles["resultScoresLegend__items__legend__label"],
                        styles[
                          `resultScoresLegend__items__legend__label--${color}`
                        ]
                      )}
                    >
                      Results Score {color}
                    </Typography>
                    <Typography
                      fontSize="text-sm"
                      className={
                        styles["resultScoresLegend__items__legend__info"]
                      }
                    >
                      {info}
                    </Typography>
                  </div>
                  {index + 1 !== resultsScoresLegendItems.length && (
                    <div
                      className={styles["resultScoresLegend__items__divider"]}
                    />
                  )}
                </Fragment>
              ))}
            </div>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </>
  );
};


// const ResultScoresLegend = () => (
//   <div className={styles["resultScoresLegend"]}>
//     <Typography
//       fontSize="text-xl"
//       fontWeight="semibold"
//       className={styles["resultScoresLegend__title"]}
//     >
//       What are Result Scores?
//     </Typography>
//     <Typography
//       fontSize="text-sm"
//       className={styles["resultScoresLegend__description"]}
//     >
//       Result Scores are VinDrives' proprietary analysis and grading of
//       actionable Key Performance Indicators (KPIs) and Critical Success Factors
//       (CSFs) of the dealership's VDP views and subsequent actions as measured
//       against the dealership's potential sales metrics and goals.
//     </Typography>

//     <div className={styles["resultScoresLegend__items"]}>
//       {resultsScoresLegendItems.map(({ color, info }, index) => (
//         <Fragment key={index}>
//           <div className={styles["resultScoresLegend__items__legend"]}>
//             <Typography
//               fontSize="text-md"
//               fontWeight="semibold"
//               className={cs(
//                 styles["resultScoresLegend__items__legend__label"],
//                 styles[`resultScoresLegend__items__legend__label--${color}`]
//               )}
//             >
//               Results Score {color}
//             </Typography>
//             <Typography
//               fontSize="text-sm"
//               className={styles["resultScoresLegend__items__legend__info"]}
//             >
//               {info}
//             </Typography>
//           </div>
//           {index + 1 !== resultsScoresLegendItems.length && (
//             <div className={styles["resultScoresLegend__items__divider"]} />
//           )}
//         </Fragment>
//       ))}
//     </div>
//   </div>
// );

export default ResultScoresLegend;